import { Component, OnInit } from '@angular/core';
import { RemessaService } from '../../../../../shared/services/remessa/remessa.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import * as moment from 'moment';
import { BoletoService } from '../../../../../shared/services/boleto/boleto.service';

import { environment } from '../../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-todos-boletos',
  templateUrl: './todos-boletos.component.html',
  styleUrls: ['./todos-boletos.component.scss']
})
export class TodosBoletosComponent implements OnInit {
  public boletos: any[];
  public boleto: any;
  public table: any = null;
  public error = false;
  public loaded = false;
  public showModal = false;

  lastSelection: any;
  firstSelection: any;

  initialDate: Date = moment().subtract(1, 'months').toDate();
  finalDate: Date = moment().toDate();

  public inputSearch = '';

  constructor(
    private boletoService: BoletoService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.showData();
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    this.table = $('#master-detail-table-boletos').DataTable({
      serverSide: true,
      processing: false,
      paging: true,
      pagingType: 'numbers',
      lengthChange: false,
      searching: false,
      order: [[2, 'desc']],
      scrollX: true,
      destroy: true,
    
      ajax: (data, callback) => {
        const user = this.localStorage.get('login');
    
        if (!user || !user.PersonId) {
          return;
        }

        const filtros: string[] = [];

        if (this.inputSearch) {
          filtros.push(`contains(tolower(SacadoNome),'${this.inputSearch}')`);
        }

        if (this.firstSelection && this.lastSelection) {
          const dataInicio = new Date(this.firstSelection.year, this.firstSelection.month - 1, this.firstSelection.day).toISOString();
          const dataFim = new Date(this.lastSelection.year, this.lastSelection.month - 1, this.lastSelection.day).toISOString();
          filtros.push(`DataVencimento ge ${dataInicio} and DataVencimento le ${dataFim}`);
        }

        const params = {
          $top: data.length,
          $skip: data.start,
          $orderBy: `${data.columns[data.order[0].column].data} ${data.order[0].dir}`,
        }

        if (filtros.length) params['$filter'] = filtros.join(' and ');

        this.boletoService.obterBoletos(user.PersonId, params).subscribe((response: any) => {
          this.loaded = true;

          callback({
            draw: data.draw,
            recordsTotal: response['@odata.count'],
            recordsFiltered: response['@odata.count'],
            data: response.value
          });
        });
      },
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },

      columns: [
        { title: 'Nome do Cliente', data: 'SacadoNome' },
        {
          title: 'Vencimento',
          data: 'DataVencimento',
          render: function (data, type, row) {
            if (row.DataVencimento) {
              return moment(row.DataVencimento).utc(false).format('DD/MM/YYYY');
            }
            return null;
          }
        },
        {
          title: 'Valor',
          data: 'Valor',
          render: function (data, type, row) {
            return (row.Valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          }
        },
        {
          title: '',
          class: 'download-remessa',
          data: null,
          orderable: false,
          render: function(data) {
            const url = environment.production ? 'https://' + data.BoletoUrl : 'https://s3.amazonaws.com/' + data.BoletoUrl;

            return '<a href="' + url + '" target="_blank">' +
                     '<i class="fa fa-eye" style="font-size: 20px;"></i>' +
                   '</a>';
          },
        },
      ],
    });

    this.rowClickListener();

    $('#master-detail-table-boletos').on('page.dt', function() {
      self.rowClickListener();
    });
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table-boletos tbody').on('click', 'tr', function(e) {
      if (e.target.className !== 'fa fa-eye') {
        const data = self.table.row(this).data();
        self.boleto = {
          ...data,
          DataVencimento: moment(data.DataVencimento).utc(false).format('DD/MM/YYYY'),
          Valor: (data.Valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        };
        self.showModal = true;
      }
    });
  }

  eventClose() {
    this.showModal = false;
  }

  setFilterData(e?: any) {
    if (e) {
      this.firstSelection = e.firstSelection;
      this.lastSelection = e.lastSelection;
    }

    this.error = false;
    this.table.ajax.reload();
  }

  public filter() {
    this.error = false;
    this.table.ajax.reload();
  }
}
